import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login.component';
import { NgModule } from '@angular/core';
// import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { InternasionalPhoneModule } from '../../components/internasional-phone/internasional-phone.module';
import { MaterialModule } from '../../../material.module';
import { SharedModule } from '../../shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { LoaderModule } from '../loader/loader.module';


@NgModule({
  declarations: [
    LoginComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    InternasionalPhoneModule,
    MaterialModule,
    ReactiveFormsModule,
    SharedModule,
    TranslateModule,
    LoaderModule
  ],
  exports: [
    LoginComponent
  ]
})
export class LoginModule { }
